import { useEffect, useState } from 'react'
import Image from 'next/image'

export default function TrustpilotStarsImage() {
  const [stars, setStars] = useState<number | null>(null)

  useEffect(() => {
    const fetchRating = async () => {
      const res = await fetch('/api/trustpilot')
      const data = await res.json()
      setStars(data.stars)
    }

    fetchRating()
  }, [])

  if (!stars) return null

  const rounded = Math.round(stars * 10) / 10
  const imageUrl = `https://images-static.trustpilot.com/api/stars/${rounded}/star.svg`

  return <Image src={imageUrl} alt={`Trustpilot ${rounded} out of 5 stars`} width={80} height={16} loading="lazy" />
}
